import { useEffect } from "react";
import {Link, useNavigate} from "react-router-dom";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useTheme, useResource, usePage, useToast } from "@/comn/hooks";
import { APIS, URLS, SF_ACSS_SRCH, SG_ACSS_LIST } from "@/tra/tancis/ptli/ststcl/acss/services/PtliAcssStstclService";
import dayjs from "dayjs";

/*
 * Access Statistics List
 * !== 접속 통계 목록 ==!
 */
export const PTLI1011001Q = (): JSX.Element => {
    const toast                  = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    }); 
    const { theme }              = useTheme();
    const navigate               = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({ defaultSchema: [{ area: "comnCd", comnCd: "COM0024" }] });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        acssSrch: useForm({
              defaultSchema: SF_ACSS_SRCH
            , defaultValues:
                {
                    ...pgeStore?.form,
                    acssDtStrt : comnUtils.getDate({ m: -1 }),
                    acssDtEnd  : comnUtils.getDate()
                } || {},
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        acssList: useGrid({
            defaultSchema: SG_ACSS_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAcssStstclList: useFetch({
            api       : (page = grid.acssList.page) => APIS.getAcssStstclList(form.acssSrch.getValues(), page, grid.acssList.size),
            enabled   : comnUtils.isEmpty(form.acssSrch.errors) && form.acssSrch.isSubmitted,
            key       : [grid.acssList.page, grid.acssList.size],
            onSuccess : () => {
                setStore(pgeUid, {
                    form: form.acssSrch.getValues(),
                    page: grid.acssList.page,
                    size: grid.acssList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            menuNm: (props: any) => {
                const { rowValues, value } = props;
                const usrId = comnUtils.isEmpty(form.acssSrch.getValue("usrId")) ? "" : `?usrId=${form.acssSrch.getValue("usrId")}`;
                return (
                    <Link to={`${URLS.ptli1011002q}/${dayjs(rowValues.acssDt).format("YYYY-MM-DD")}/${rowValues.menuId}${usrId}`}>
                        {value}
                    </Link>
                );
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: () => {
            form.acssSrch.handleSubmit(
                () => {
                    grid.acssList.setPage(0);
                    fetch.getAcssStstclList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        }
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick();
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.acssSrch.schema.acssDt} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.acssSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.acssSrch.schema.usrId} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.acssSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={ handler.onSrchBtnClick } />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.acssList.grid}
                            data={fetch.getAcssStstclList.data?.acssStstclList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
